<template>
	<div class="candy" v-if="p_candy">
		<template v-if="!c_product_discount_bbva">
			<div class="candy-img">
				<a @click.prevent="m_show_candy(p_candy)">
					<img :src="c_get_src" :alt="p_candy.strDescription" />
				</a>
			</div>
			<div class="candy-content">
				<div class="candy-title">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strTitle }}</span>
					</a>
				</div>
				<div class="candy-code" v-if="p_candy.strBarcode && p_candy.strBarcode != ''">
					<span>CÓDIGO {{ p_candy.strBarcode }}</span>
				</div>
				<div class="candy-description">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strDescription }}</span>
					</a>
				</div>
				<template v-if="$root.d_member && $root.d_member.intLoyaltyLevel > 1 && !c_product_ypf && (!p_candy.strBarcode || p_candy.strBarcode == '')">
					<div class="candy-descuentos">
						<div class="candy-descuentos-content">
							<span>Por ser socio</span>
							<template v-if="$root.d_member.intLoyaltyLevel == 2">
								<img :src="$root.d_get_url_merch + 'images/logo-clubfan.png?v=' + $root.d_get_date_version_cache" class="img-responsive small" />
							</template>
							<template v-else-if="$root.d_member.intLoyaltyLevel == 3">
								<img :src="$root.d_get_url_merch + 'images/logo-clubplus.png?v=' + $root.d_get_date_version_cache" class="img-responsive small" />
							</template>
							<template v-else>
								<img :src="$root.d_get_url_merch + 'images/logo-clubblack.png?v=' + $root.d_get_date_version_cache" class="img-responsive small" />
							</template>
						</div>
						<span>tenés <span class="bold">descuentos exclusivos.</span></span>
					</div>
				</template>
				<div v-else-if="c_product_ypf" class="candy-ypfserviclub">
					<span class="bold">SOCIO YPF SERVICLUB</span><br><span>Canjeá tus KMS por este beneficio</span>
				</div>
				<template v-else></template>
				<div class="candy-price">
					<template v-if="$root.d_member && $root.d_member.intLoyaltyLevel > 1 && p_candy.BuyOptions.filter(candy => candy.intType == 3 && (candy.intRecogId > 0 || candy.intPromoId != 0)).length > 0">
						<template v-if="p_candy.strBarcode && p_candy.strBarcode != ''">
							<span>Precio: {{ c_get_price_descuento }}</span>
						</template>
						<template v-else>
							<span>Precio: <br class="visible-xs" /><span class="price-before">${{ (p_candy.SalePrice / 100).toLocaleString('es-AR') }}</span> {{ c_get_price_descuento }}</span>
						</template>
					</template>
					<template v-else-if="c_product_ypf">
						<span>Precio: <br class="visible-xs" />{{ m_get_price_ypf(p_candy) }}</span>
					</template>
					<template v-else>
						<span>Precio: <br class="visible-xs" />${{ p_candy.PercentDiscount == 0 ? (p_candy.SalePrice / 100).toLocaleString('es-AR') : p_candy.SalePrice.toLocaleString('es-AR') }}</span>
					</template>
				</div>
				<div class="candy-price-wtax" v-if="p_candy.SalePriceWTax > 0 && !c_product_ypf">
					<template v-if="$root.d_member && $root.d_member.intLoyaltyLevel > 1 && p_candy.BuyOptions.filter(candy => candy.intType == 3 && candy.intValueWTax > 0 && (candy.intRecogId > 0 || candy.intPromoId != 0)).length > 0">
						<template v-if="p_candy.strBarcode && p_candy.strBarcode != ''">
							<span>Precio sin impuestos nacionales: {{ c_get_price_descuento_wtax }}</span>
						</template>
						<template v-else>
							<span>Precio sin impuestos nacionales: <br class="visible-xs" /><span class="price-before">${{ (p_candy.SalePriceWTax / 100).toLocaleString('es-AR') }}</span> {{ c_get_price_descuento_wtax }}</span>
						</template>
					</template>
					<template v-else>
						<span>Precio sin impuestos nacionales: ${{ p_candy.PercentDiscount == 0 ? (p_candy.SalePriceWTax / 100).toLocaleString('es-AR') : p_candy.SalePriceWTax.toLocaleString('es-AR') }}</span>
					</template>
				</div>
				<div v-if="!c_product_ypf" class="candy-cuotas">
					<span>3 cuotas sin interes con</span>
					<img :src="$root.d_get_url_merch + 'images/bbva.png?v=' + $root.d_get_date_version_cache" />
				</div>
				<div class="candy-button">
					<div class="row">
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">MÁS INFO</a>
						</div>
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">{{ m_get_text_button_buy() }}</a>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="candy-img">
				<a @click.prevent="m_show_candy(p_candy)">
					<img :src="c_get_src" :alt="p_candy.strDescription" />
				</a>
			</div>
			<div class="candy-content">
				<div class="candy-title">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strTitle }}</span>
					</a>
				</div>
				<div class="candy-description">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strDescription }}</span>
					</a>
				</div>
				<div class="candy-discount">
					<span v-html="c_product_discount_bbva_msge"></span>
				</div>
				<div class="candy-price">
					<template v-if="$root.d_member && $root.d_member.intLoyaltyLevel > 1 && p_candy.BuyOptions.filter(candy => candy.intType == 3 && (candy.intRecogId > 0 || candy.intPromoId != 0)).length > 0">
						<span>Precio: <br class="visible-xs" /><span class="price-before">${{ (p_candy.SalePrice / 100).toLocaleString('es-AR') }}</span> {{ c_get_price_descuento }}</span>
					</template>
					<template v-else>
						<span>Precio: <br class="visible-xs" />${{ p_candy.PercentDiscount == 0 ? (p_candy.SalePrice / 100).toLocaleString('es-AR') : p_candy.SalePrice.toLocaleString('es-AR') }}</span>
					</template>
				</div>
				<div class="candy-price-wtax" v-if="p_candy.SalePriceWTax > 0">
					<template v-if="$root.d_member && $root.d_member.intLoyaltyLevel > 1 && p_candy.BuyOptions.filter(candy => candy.intType == 3 && candy.intValueWTax > 0 && (candy.intRecogId > 0 || candy.intPromoId != 0)).length > 0">
						<span>Precio sin impuestos nacionales: <br class="visible-xs" /><span class="price-before">${{ (p_candy.SalePriceWTax / 100).toLocaleString('es-AR') }}</span> {{ c_get_price_descuento_wtax }}</span>
					</template>
					<template v-else>
						<span>Precio sin impuestos nacionales: <br class="visible-xs" />${{ p_candy.PercentDiscount == 0 ? (p_candy.SalePriceWTax / 100).toLocaleString('es-AR') : p_candy.SalePriceWTax.toLocaleString('es-AR') }}</span>
					</template>
				</div>
				<div class="candy-cuotas">
					<span>3 cuotas sin interes con</span>
					<img :src="$root.d_get_url_merch + 'images/bbva.png?v=' + $root.d_get_date_version_cache" />
				</div>
				<div class="candy-button">
					<div class="row">
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">MÁS INFO</a>
						</div>
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">{{ m_get_text_button_buy() }}</a>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
	name: 'candyticket',
	props: {
		p_candy: { type: Object, default: () => null }
	},
	computed: {
		c_get_src: function () {
			if (!this.p_candy.strCssClass.includes('gif')) {
				return this.$root.d_get_url_candy_images + this.p_candy.strMCode + '.png?v=' + this.$root.d_get_date_version_cache;
			}
			else {
				return this.$root.d_get_url_candy_images + this.p_candy.strMCode + '.gif?v=' + this.$root.d_get_date_version_cache;
			}
		},
		c_get_price_descuento: function () {
			var price = "";

			this.p_candy.BuyOptions.forEach(buyoption => {
				if (buyoption.intType == 3 && (buyoption.intRecogId > 0 || buyoption.intPromoId != 0)) {
					price = "$" + (buyoption.intValue / 100).toLocaleString('es-AR');
					return;
				}
			});

			return price;
		},
		c_get_price_descuento_wtax: function () {
			var price = "";

			this.p_candy.BuyOptions.forEach(buyoption => {
				if (buyoption.intType == 3 && (buyoption.intRecogId > 0 || buyoption.intPromoId != 0)) {
					price = "$" + (buyoption.intValueWTax / 100).toLocaleString('es-AR');
					return;
				}
			});

			return price;
		},
		c_product_ypf: function () {
			var is_product_ypf = false;

			this.p_candy.BuyOptions.forEach(buyoption => {
				if (buyoption.intType == 4) {
					is_product_ypf = true;
				}
			});

			return is_product_ypf;
		},
		c_product_discount_bbva: function () {
			var is_product_discount_bbva = false;

			var productList = this.$root.d_get_discount_bbva_product_list.split(';');

			productList.forEach(product => {
				if (product != '' && product == this.p_candy.strMCode) {
					is_product_discount_bbva = true;
				}
			});

			return is_product_discount_bbva;
		},
		c_product_discount_bbva_msge: function () {
			var message = "";

			var productMsgs = this.$root.d_get_discount_bbva_product_msgs.split(';;');

			productMsgs.forEach(productMsg => {
				var productMsgList = productMsg.split('--');

				if (productMsgList[0] != '' & productMsgList[0] == this.p_candy.strMCode) {
					message = productMsgList[1];
				}
			});

			return message;
		}
	},
	methods: {
		m_show_candy: function (candy) {
			this.$root.m_show_popup_candy(candy);
		},
		m_get_text_button_buy: function () {
			var button_text = "COMPRAR";

			if (this.$root.d_cart_candys != null) {
				this.$root.d_cart_candys.forEach(orderItem => {
					if (orderItem.strMCode == this.p_candy.strMCode) {
						button_text = "AGREGAR";
					}
				});
			}

			return button_text;
		},
		m_get_price_ypf: function (p_candy) {
			var price = "";

			p_candy.BuyOptions.forEach(buyoption => {
				if (buyoption.intType == 4) {
					buyoption.lstBalances.forEach(balance => {
						if (balance.intPoints > 0) {
							price = `${balance.intPoints.toLocaleString('es-AR')} ${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}`;
						}
					});
				}
			});

			return price;
		},
		m_get_balance_name: function (enuPointsType, intBalanceId, plural) {
			return this.$root.m_get_balance_name(enuPointsType, intBalanceId, false, plural);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/CandyTicket.vue